import { Button } from "components/atoms";
import { useLanguages, useLanguagesActions } from "hooks/useLanguagesOptions";
import { t } from "i18next";
import i18n from "locales/i18n";
import { upperCase } from "lodash";
import { useStoreState } from "providers/StoreStateContext";
import { useMemo } from "react";
import { PiMoon, PiPower, PiSun } from "react-icons/pi";
import { useGetDefaultValues } from "services/settings/individual";
import { THEME_TYPE } from "store/theme";
import { BUTTON_VARIANT } from "types/components/button/button.interface";

const PublicConfigurationButtons = () => {
  const { setThemeType, themeType, clearTokens, token, theme } =
    useStoreState();
  const { languages } = useLanguages();
  const { getLanguagesOptions } = useLanguagesActions();
  const defaultValues = useGetDefaultValues();

  const currentTheme = useMemo(
    () => themeType ?? THEME_TYPE.light,
    [themeType],
  );

  const language = useMemo(
    () =>
      i18n.language ??
      defaultValues.data?.defaultLanguage.language.split("-")[0] ??
      "en",
    [defaultValues.data?.defaultLanguage.language, i18n.language],
  );

  return (
    <div className="flex gap-4">
      <Button
        onlyIcon
        variant={BUTTON_VARIANT.background}
        onClick={() => i18n.changeLanguage(language === "pl" ? "en" : "pl")}
      >
        <Button.Icon
          icon={
            <img
              src={`https://flagsapi.com/${
                language === "en" ? "GB" : upperCase(language)
              }/flat/32.png`}
              className="w-[20px] rounded"
            />
          }
        />
        <Button.Description
          description={t(`enum.supportedLanguages.${language}`)}
        />
      </Button>
      {/* {theme?.canChangeThemeMode && ( */}
      {theme?.canChangeThemeMode && (
        <Button
          onlyIcon
          variant={BUTTON_VARIANT.background}
          onClick={() => {
            const selectedThemeMode =
              currentTheme === THEME_TYPE.light
                ? THEME_TYPE.dark
                : THEME_TYPE.light;
            localStorage.setItem("theme-mode", `${selectedThemeMode}`);
            setThemeType(selectedThemeMode as THEME_TYPE);
          }}
        >
          <Button.Icon
            icon={currentTheme === THEME_TYPE.light ? <PiSun /> : <PiMoon />}
          />
          <Button.Description
            description={t(
              `enum.THEME_TYPE.${
                THEME_TYPE[
                  currentTheme === THEME_TYPE.dark
                    ? THEME_TYPE.dark
                    : THEME_TYPE.light
                ]
              }`,
            )}
          />
        </Button>
      )}
      {/* )} */}
      {token !== null && (
        <Button
          onlyIcon
          variant={BUTTON_VARIANT.background}
          onClick={clearTokens}
        >
          <Button.Icon icon={<PiPower />} />
          <Button.Description description={t("navbar.logout")} />
        </Button>
      )}
    </div>
  );
};

export default PublicConfigurationButtons;
